"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("./../configuration");
var LiteEvent = (function () {
    function LiteEvent() {
        this.listeners = [];
    }
    LiteEvent.prototype.on = function (handler) {
        if (this.listeners.indexOf(handler) === -1) {
            this.listeners.push(handler);
        }
    };
    LiteEvent.prototype.off = function (handler) {
        var index = this.listeners.indexOf(handler);
        if (index !== -1) {
            this.listeners.splice(index, 1);
        }
    };
    LiteEvent.prototype.fire = function () {
        var p = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            p[_i] = arguments[_i];
        }
        var args = arguments;
        this.listeners.forEach(function (handler) {
            try {
                handler.apply(undefined, args);
            }
            catch (error) {
                configuration_1.PlanConfiguration.logger.error("exception caught from row changed callback:");
                configuration_1.PlanConfiguration.logger.error(error);
            }
        });
    };
    return LiteEvent;
}());
exports.LiteEvent = LiteEvent;
//# sourceMappingURL=liteEvent.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/liteEvent.js
// module id = 33
// module chunks = 0